<div style="margin-bottom: 10px;">
  <input
    type="text"
    class="project-multi-selector-search"
    placeholder="Search project number or description"
    [(ngModel)]="search"
    (input)="applyProjectFilter()" />
</div>
<div *ngIf="isLoading">Loading projects...</div>
<div *ngIf="!isLoading">
  <div class="project-multi-selector-select">
    <div
      *ngFor="let project of filteredProjects"
      class="project-multi-selector-option"
      [class.project-multi-selector-option-selected]="selectedProjectIds.includes(project.Id)"
      (click)="toggleProject(project.Id)">
      <input
        type="checkbox"
        [attr.aria-label]="'Select project ' + project.ProjectNumber"
        [checked]="selectedProjectIds.includes(project.Id)"
        (click)="$event.stopPropagation()"
        (change)="toggleProject(project.Id)" />
      <span>{{ project.ProjectNumber }} - {{ project.ItemDescription }}</span>
    </div>
  </div>
  <div class="project-multi-selector-summary">
    Selected {{ selectedProjectIds.length }} project(s): {{ selectedProjectNumbers }}
  </div>
</div>
